import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../shared/services/AuthService';

@Component({
    selector: 'login-page',
    templateUrl: './login.page.html',
    host: { '(window:keyup)': 'hotkeys($event)' },
})
export class LoginPage {


    username: string = null;
    password: string = null;
    isLoading: boolean = false;
    message:string = null;




    constructor(private router: Router, private authService: AuthService) {
        this.authService.logout();
    }

    hotkeys(e) {
        if (e.key == "Enter") {
            this.login();
        }
    }

    login() {
        this.isLoading = true;
        this.message = null;
        this.authService.login(this.username, this.password).then(c => {
            this.isLoading = false;
            this.router.navigate(['/dashboard']);
        }).catch(err => {
            this.message = err;
            this.isLoading = false;
        });
    }
}




// WEBPACK FOOTER //
// D:/Works/Safetyminder/Safetyminder/Admin/src/app/admin/shared/pages/login.page.ts